import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";

const ArticleHelmet = props => {
  const {
    title,
    subtitle,
    archive,
    path,
    date,
    update_date: updateDate
  } = props.article;
  const metaImagePath =
    props.metaImagePath &&
    `https://www.javascriptstuff.com${props.metaImagePath}`;

  return (
    <Helmet>
      <title>{title}</title>

      {/* Robots */}
      {archive && <meta name="robots" content="noindex" />}

      {/* General meta tags */}
      <meta name="title" content={title} />
      <meta name="description" content={subtitle} />
      <meta itemProp="title" content={title} />
      <meta itemProp="description" content={subtitle} />
      {metaImagePath && <meta itemProp="image" content={metaImagePath} />}

      {/* Twitter card */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@ahfarmer" />
      <meta name="twitter:creator" content="@ahfarmer" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={subtitle} />
      {metaImagePath && <meta name="twitter:image" content={metaImagePath} />}

      {/* Open Graph */}
      <meta name="og:title" content={title} />
      <meta name="og:type" content="article" />
      <meta name="og:url" content={`https://www.javascriptstuff.com${path}`} />
      <meta name="og:description" content={subtitle} />
      <meta name="og:published_time" content="JavaScript Stuff" />
      <meta name="og:site_name" content="JavaScript Stuff" />
      <meta name="article:published_time" content={date} />
      {updateDate && <meta name="article:modified_time" content={updateDate} />}
      {metaImagePath && <meta name="og:image" content={metaImagePath} />}
    </Helmet>
  );
};
ArticleHelmet.propTypes = {
  article: PropTypes.shape({
    date: PropTypes.string.isRequired,
    update_date: PropTypes.string,
    path: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    archive: PropTypes.bool
  }).isRequired,
  metaImagePath: PropTypes.string
};
ArticleHelmet.defaultProps = {
  metaImagePath: null
};
export default ArticleHelmet;



// WEBPACK FOOTER //
// ./src/components/article/ArticleHelmet.js